/* eslint-disable react/destructuring-assignment */
import React, { useContext, useState } from "react";
import { bool, func, string } from "prop-types";
import CustomText from "pages/_components/CustomText/CustomText";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import FormattedDate from "pages/_components/FormattedDate";
import Avatar from "pages/_components/Avatar";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";
import { TransactionSign } from "pages/_components/TransactionCard";
import GridTable from "pages/_components/GridTable/GridTable";
import Button from "pages/_components/Button";
import { resizableRoute } from "pages/_components/Resizable";

const PayDebinSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { idTransactionStatus } = transaction;
    const { showMoreData, setShowMoreData, isDesktop } = props;
    const { data = {} } = transaction;
    const {
        sellerName = props.sellerName,
        sellerCuit = props.sellerCuit,
        amountSumary = props.amountSumary,
        solicitDate = props.solicitDate,
        dueDate = props.dueDate,
        debinId = props.debinId,
        sellerCbu = props.sellerCbu,
        alias = props.alias,
        bank = props.bank,
        concept = props.concept,
        description = props.description,
        reference = props.reference,
        curencySeller = props.curencySeller,
        debitAccountMask = props.debitAccountMask,
    } = data;
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };
    return (
        <>
            {props.isTicket ? (
                <div className="ticket__body debin-credin-list">
                    <div className="ticket-header-info">
                        <div className="beneficiary">
                            <div className="avatar-name">
                                <Avatar user={{ userFullName: sellerName, defaultAvatarId: 0 }} />
                            </div>
                            <div className="user-info">
                                <CustomText className="small" text="debin.seller" textType="I18N" />
                                <CustomText className="large" text={`${sellerName} `} />
                                <CustomText className="small" text={`${sellerCuit} `} />
                            </div>
                        </div>

                        <CustomData
                            dataClass={`amount tag tag-${idTransactionStatus}`}
                            titleText="debin.amount"
                            titleTextType="I18N"
                            valueText={<FormattedAmount currency={curencySeller} quantity={amountSumary} />}
                        />
                    </div>

                    <div className="view-more-data-button" id="element-to-ignore">
                        <div className="ticket__divider inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <Button
                            aria-expanded={showMoreData ? "true" : "false"}
                            className="more-button"
                            label={buttonLabel}
                            bsStyle="link"
                            onClick={handleSeeMoreData}
                            image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                        />
                    </div>
                    <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                        <CustomData
                            titleText="debin.solicit.date"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={solicitDate} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                        />
                        <CustomData
                            titleText="debin.expirery.date"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={dueDate} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                        />
                        <CustomData titleText="debin.id" titleTextType="I18N" valueText={debinId} />
                        <div className="ticket__divider inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <CustomData titleText="debin.cbu" titleTextType="I18N" valueText={sellerCbu} />
                        <CustomData titleText="debin.alias" titleTextType="I18N" valueText={alias} />
                        <CustomData titleText="debin.bank.branch" titleTextType="I18N" valueText={bank} />
                        <div className="ticket__divider inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <CustomData
                            titleText="debin.dateExpitation"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={` ${debitAccountMask}`} />}
                        />
                        <CustomData titleText="debin.concept.label" titleTextType="I18N" valueText={concept} />
                        <CustomData titleText="debin.description.label" titleTextType="I18N" valueText={description} />
                        <CustomData titleText="debin.reference" titleTextType="I18N" valueText={reference} />
                        <TransactionSign isDesktop={isDesktop} showMoreData={showMoreData} hasVaucher />
                    </div>
                </div>
            ) : (
                <>
                    <GridTable className="details debin-credin-list">
                        <GridTable.Container columns={isDesktop ? 3 : 1} rows={isDesktop ? 5 : 15}>
                            <GridTable.Data columnStart={1} rowStart={1} columnWidth={3}>
                                <div className="debin-payments__received-head">
                                    <CustomData
                                        dataClass="seller"
                                        titleText="debin.seller"
                                        titleTextType="I18N"
                                        valueText={
                                            <div className="debin-payments__container-seller">
                                                <Avatar user={{ userFullName: sellerName, defaultAvatarId: 0 }} />
                                                <div className="d-flex flex-column">
                                                    <CustomText
                                                        className="data-label debin-payments__received-name"
                                                        text={`${sellerName} `}
                                                    />
                                                    <CustomText className="data-label" text={`${sellerCuit} `} />
                                                </div>
                                            </div>
                                        }
                                    />
                                    <CustomData
                                        titleText="debin.amount"
                                        titleTextType="I18N"
                                        valueText={<FormattedAmount currency={curencySeller} quantity={amountSumary} />}
                                    />
                                </div>
                            </GridTable.Data>

                            <GridTable.Data
                                className="flex"
                                columnStart={1}
                                rowStart={2}
                                columnWidth={isDesktop ? 3 : 1}>
                                <hr className="dotted" />
                            </GridTable.Data>

                            <GridTable.Data columnStart={1} rowStart={3} columnWidth={1}>
                                <CustomData
                                    titleText="debin.solicit.date"
                                    titleTextType="I18N"
                                    valueText={<FormattedDate date={solicitDate} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                                />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={isDesktop ? 2 : 1}
                                rowStart={isDesktop ? 3 : 4}
                                columnWidth={1}>
                                <CustomData
                                    titleText="debin.expirery.date"
                                    titleTextType="I18N"
                                    valueText={<FormattedDate date={dueDate} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                                />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={isDesktop ? 3 : 1}
                                rowStart={isDesktop ? 3 : 5}
                                columnWidth={1}>
                                <CustomData titleText="debin.id" titleTextType="I18N" valueText={debinId} />
                            </GridTable.Data>

                            <GridTable.Data
                                className="flex"
                                columnStart={1}
                                rowStart={isDesktop ? 4 : 6}
                                columnWidth={isDesktop ? 3 : 1}>
                                <hr className="dotted" />
                            </GridTable.Data>

                            <GridTable.Data columnStart={1} rowStart={isDesktop ? 5 : 7} columnWidth={1}>
                                <CustomData titleText="debin.cbu" titleTextType="I18N" valueText={sellerCbu} />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={isDesktop ? 2 : 1}
                                rowStart={isDesktop ? 5 : 8}
                                columnWidth={1}>
                                <CustomData titleText="debin.alias" titleTextType="I18N" valueText={alias} />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={isDesktop ? 3 : 1}
                                rowStart={isDesktop ? 5 : 9}
                                columnWidth={1}>
                                <CustomData titleText="debin.bank.branch" titleTextType="I18N" valueText={bank} />
                            </GridTable.Data>

                            <GridTable.Data
                                className="flex"
                                columnStart={1}
                                rowStart={isDesktop ? 6 : 10}
                                columnWidth={isDesktop ? 3 : 1}>
                                <hr className="dotted" />
                            </GridTable.Data>

                            <GridTable.Data columnStart={1} rowStart={isDesktop ? 7 : 11} columnWidth={1}>
                                <CustomData titleText="debin.concept.label" titleTextType="I18N" valueText={concept} />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={isDesktop ? 2 : 1}
                                rowStart={isDesktop ? 7 : 12}
                                columnWidth={1}>
                                <CustomData
                                    titleText="debin.description.label"
                                    titleTextType="I18N"
                                    valueText={description}
                                />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={isDesktop ? 3 : 1}
                                rowStart={isDesktop ? 7 : 13}
                                columnWidth={1}>
                                <CustomData titleText="debin.reference" titleTextType="I18N" valueText={reference} />
                            </GridTable.Data>
                            <GridTable.Data
                                className="flex"
                                columnStart={1}
                                rowStart={isDesktop ? 8 : 14}
                                columnWidth={isDesktop ? 3 : 1}>
                                <hr className="dotted" />
                            </GridTable.Data>
                            <GridTable.Data columnStart={1} rowStart={isDesktop ? 9 : 15} columnWidth={1}>
                                <CustomData
                                    titleText="debin.dateExpitation"
                                    titleTextType="I18N"
                                    valueText={debitAccountMask}
                                />
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable>
                </>
            )}
        </>
    );
};

PayDebinSummaryBody.propTypes = {
    sellerName: string,
    sellerCuit: string,
    amountSumary: string,
    solicitDate: string,
    dueDate: string,
    debinId: string,
    sellerCbu: string,
    alias: string,
    bank: string,
    concept: string,
    description: string,
    reference: string,
    curencySeller: string,
    debitAccountMask: string,
    showMoreData: bool,
    setShowMoreData: func,
    isTicket: bool,
    isDesktop: bool.isRequired,
};

PayDebinSummaryBody.defaultProps = {
    sellerName: "",
    sellerCuit: "",
    amountSumary: "",
    solicitDate: "",
    dueDate: "",
    debinId: "",
    sellerCbu: "",
    alias: "",
    bank: "",
    concept: "",
    description: "",
    reference: "",
    curencySeller: "",
    debitAccountMask: "",
    showMoreData: false,
    setShowMoreData: () => {},
    isTicket: false,
};

export default resizableRoute(PayDebinSummaryBody);
